import { render, staticRenderFns } from "./switchAddress.vue?vue&type=template&id=40d71cc6&scoped=true"
import script from "./switchAddress.vue?vue&type=script&lang=js"
export * from "./switchAddress.vue?vue&type=script&lang=js"
import style0 from "./switchAddress.vue?vue&type=style&index=0&id=40d71cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d71cc6",
  null
  
)

export default component.exports